import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { addZendeskHideReason, removeZendeskHideReason } from 'utils/zendesk';

const HIDE_REASON = 'route';

// The launcher overlaps the map controls, and support is not reachable for
// signed-out users anyway.
const HIDDEN_ROUTES = [
  '/map',
  '/login',
  '/login/password',
  '/login-v2',
  '/register',
  '/forgot-password',
  '/reset-password',
];

const ZendeskRouteVisibility = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const shouldHide = HIDDEN_ROUTES.some((route) =>
      matchPath({ path: route, end: true }, pathname)
    );

    if (shouldHide) {
      addZendeskHideReason(HIDE_REASON);
    } else {
      removeZendeskHideReason(HIDE_REASON);
    }
  }, [pathname]);

  return null;
};

export default ZendeskRouteVisibility;
